module.exports = __webpack_public_path__ + "static/media/docker.71183073.svg";